import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Phone, MapPin, Mail } from "lucide-react";
import { SITE } from "@/data/site";
import NewsletterSignup from "@/components/NewsletterSignup";

const Footer = () => {
    return (
        <footer className="acd-footer mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 pt-20 pb-4">
                <NewsletterSignup />
            </div>
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
                <div>
                    <img
                        src={SITE.logoUrl}
                        alt="ACD Advogados"
                        className="h-16 mb-4 bg-white/95 rounded p-2"
                    />
                    <p className="text-sm leading-relaxed text-gray-300">
                        Assessoria jurídica de excelência desde 1995. Rigor,
                        transparência e proximidade humana ao serviço dos seus
                        interesses.
                    </p>
                    <div className="flex gap-3 mt-5">
                        <a
                            href={SITE.social.facebook}
                            target="_blank"
                            rel="noreferrer"
                            className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition"
                            data-testid="footer-facebook"
                        >
                            <Facebook size={16} />
                        </a>
                        <a
                            href={SITE.social.instagram}
                            target="_blank"
                            rel="noreferrer"
                            className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition"
                            data-testid="footer-instagram"
                        >
                            <Instagram size={16} />
                        </a>
                        <a
                            href={SITE.social.linkedin}
                            target="_blank"
                            rel="noreferrer"
                            className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition"
                            data-testid="footer-linkedin"
                        >
                            <Linkedin size={16} />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="text-white uppercase tracking-widest text-xs font-bold mb-4">
                        Navegação
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/" className="hover:text-white transition">
                                Início
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/areas-de-atuacao"
                                className="hover:text-white transition"
                            >
                                Áreas de Atuação
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/recrutamento"
                                className="hover:text-white transition"
                            >
                                Recrutamento
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/artigos"
                                className="hover:text-white transition"
                            >
                                Artigos
                            </Link>
                        </li>
                    </ul>
                </div>

                {SITE.offices.map((o) => (
                    <div key={o.city}>
                        <h4 className="text-white uppercase tracking-widest text-xs font-bold mb-4">
                            {o.region}
                        </h4>
                        <h5 className="text-white font-semibold mb-2 text-sm">
                            {o.city}
                        </h5>
                        <div className="flex gap-2 items-start text-sm text-gray-300 mb-2">
                            <MapPin size={16} className="mt-1 shrink-0" />
                            <span>{o.address}</span>
                        </div>
                        {o.phones.map((p) => (
                            <div
                                key={p}
                                className="flex gap-2 items-center text-sm text-gray-300"
                            >
                                <Phone size={14} className="shrink-0" />
                                <a
                                    href={`tel:+351${p.replace(/\s/g, "")}`}
                                    className="hover:text-white"
                                >
                                    {p}
                                </a>
                            </div>
                        ))}
                        <p className="text-xs text-gray-400 mt-1">{o.note}</p>
                    </div>
                ))}
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-400">
                    <p>
                        © {new Date().getFullYear()} {SITE.fullName}. Todos os
                        direitos reservados.
                    </p>
                    <div className="flex items-center gap-2">
                        <Mail size={14} />
                        <a
                            href={`mailto:${SITE.email}`}
                            className="hover:text-white"
                        >
                            {SITE.email}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
